import { html, TemplateResult, CSSResultGroup } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import componentStyles from './outline-video-youtube.css.lit';
import { OutlineElement } from '../../base/outline-element/outline-element';
import { classMap } from 'lit/directives/class-map.js';
import YTPlayer from 'yt-player';
import { LightDomStyles } from '../../controllers/light-dom-styles';

export interface OutlineVideoYoutubeInterface extends HTMLElement {
  videoID: string;
}

/**
 * The Outline VideoYoutube component
 *
 * @element outline-video-youtube
 */
@customElement('outline-video-youtube')
export class OutlineVideoYoutube
  extends OutlineElement
  implements OutlineVideoYoutubeInterface
{
  lightDomStyles = new LightDomStyles(this, componentStyles);
  static styles: CSSResultGroup = [componentStyles];

  @property({ type: String, reflect: true, attribute: 'id-rand' })
  idRand = `player-${Math.floor(Math.random() * 10000).toString()}`;

  @property({ type: String, attribute: 'video-id' })
  videoID: string;

  @property({ type: String, attribute: 'video-thumb' })
  videoThumb: string;

  @state()
  videoThumbState: boolean;

  ytPlayer: YTPlayer;

  firstUpdated() {
    const id = this.idRand;
    const vid = this.videoID;
    const player = document.querySelector('#' + id) as HTMLElement;
    this.ytPlayer = new YTPlayer(player, {
      host: 'https://www.youtube-nocookie.com',
      related: false,
    });
    this.ytPlayer.load(vid);
  }

  playIconHandler() {
    this.videoThumbState = !this.videoThumbState;
    this.ytPlayer.play();
  }

  render(): TemplateResult {
    const videoThumbClasses = {
      'video-thumb': true,
      'hide': this.videoThumbState,
    };

    const videoPlayClasses = {
      'video-play': true,
      'hide': this.videoThumbState,
    };

    const videoOverlay = {
      'video-overlay': true,
      'hide': this.videoThumbState,
    };

    return html`
        ${
          this.videoThumb
            ? html`
          <div class="${classMap(videoThumbClasses)}">
            <img src="${this.videoThumb}" />
          </div>
          <div class="${classMap(videoOverlay)}"></div>
          <div class="${classMap(videoPlayClasses)}">
            <button @click="${this.playIconHandler}">
              <idb-icon icon="play-circle" stroke-width="2"></idb-icon>
            </button>
          </div>
        `
            : null
        }
        <div id="${this.idRand}">
        </div>
    `;
  }

  createRenderRoot() {
    return this;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'outline-video-youtube': OutlineVideoYoutube;
  }
}
